import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
// import{falink} from '@fortawesome/free-regular-svg-icons'

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent {}
